import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RateBeast from "./pages/RateBeast";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RateBeast />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0f0f13",
            border: "1px solid #1e1e28",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
